import {
  DateField,
  EditButton,
  List,
  ShowButton,
  Space,
  Table,
  Modal,
  useDrawerForm,
  useTable,
  Show,
  Row,
  Col,
  Title,
  Typography,
  FileField,
  RefreshButton,
} from "@pankod/refine-antd";
import { useApiUrl, useShow, useTranslate } from "@pankod/refine-core";
import { Statuses } from "components/common";
import { CreateContract, EditContract } from "components/contracts";
import { IContract } from "interfaces/contract";
import { IProject } from "interfaces/project";
import { projectStatus } from "constants/project";
import { useState } from "react";
import dayjs from "dayjs";


export const ProjectContractsTable: React.FC<{ record: IProject }> = ({
  record,
}) => {
  const API_URL = useApiUrl();
  const t = useTranslate();
  const [visible, setVisible] = useState(false);
  const {
    drawerProps: createContractsDrawerProps,
    formProps: createContractsFormProps,
    saveButtonProps: createContractsSaveButtonProps,
    show: createContractsShow,
  } = useDrawerForm<IContract>({
    action: "create",
    resource: "contracts",
    redirect: false,
    //defaultFormValues:{ name: "hhhhh"}
  });

  const { Title, Text } = Typography;

  const {
    drawerProps: editContractsDrawerProps,
    formProps: editContractsFormProps,
    saveButtonProps: editContractsSaveButtonProps,
    show: editContractsShow,
  } = useDrawerForm<IContract>({
    action: "edit",
    resource: "contracts",
    redirect: false,
  });

  const { tableProps: contractsTableProps } = useTable<IContract>({
    resource: "contracts",
    permanentFilter: [
      {
        field: "project.id",
        operator: "eq",
        value: record.id,
      },
    ],
    syncWithLocation: false,
  });

  const { queryResult, showId, setShowId } = useShow<IContract>({
    resource: "contracts",
  });
  const { data, isLoading } = queryResult;
  const record__ = data?.data;

  return (
    <>
      <List
        title={t("contracts.contracts")}
        createButtonProps={{
          onClick: () => {
            createContractsShow();
          },
          disabled:
            record?.status === projectStatus.provider_contracts.value ||
            record?.status === projectStatus.tenders.value ||
            record?.status === projectStatus.finished.value ||
            record?.status === projectStatus.rejected.value,
        }}
      >
        <Table {...contractsTableProps} rowKey="id">
          <Table.Column
            key="description"
            dataIndex="description"
            title={t("contracts.fields.name")}
          />

          <Table.Column<IContract>
            dataIndex="date"
            title={t("contracts.fields.date")}
            render={(value) => <DateField format="LLL" value={dayjs(value)} />}
          />
          <Table.Column<IContract>
            dataIndex="status"
            title={t("price_offers.fields.status")}
            render={(value) => {
              return <Statuses status={value} />;
            }}
          />

          <Table.Column<IContract>
            title={t("table.actions")}
            dataIndex="actions"
            render={(_, rec) =>
              record?.status === projectStatus.contracts.value ? (
                <Space>
                  <EditButton onClick={() => editContractsShow(rec.id)}>
                    {t("projects.buttons.editContracts")}
                  </EditButton>
                </Space>
              ) : (
                <Space>
                  <ShowButton
                    size="small"
                    resourceNameOrRouteName="contracts"
                    recordItemId={rec.id}
                    onClick={() => {
                      setShowId(rec.id);
                      setVisible(true);
                    }}
                  />
                </Space>
              )
            }
          />
        </Table>
      </List>
      <Modal visible={visible} closable={false} footer={false} width={800}>
        <Show
          isLoading={isLoading}
          pageHeaderProps={{
            onBack: () => setVisible(false),
            extra: <RefreshButton hidden/>
          }}
          resource="contracts"
          recordItemId={showId}
        >
          <Row gutter={20}>
            <Col xs={24} lg={30}>
              <Row gutter={10}>
                <Col xs={24} lg={12}>
                  <Title level={5}>{t("contracts.fields.description")}</Title>
                  <Text>{record__?.description}</Text>

                  <Title level={5}>
                    {t("contracts.fields.nameOfContractor")}
                  </Title>
                  <Text>{record__?.nameOfContractor}</Text>

                  <Title level={5}>
                    {t("contracts.fields.contractorPosition")}
                  </Title>
                  <Text>{record__?.contractorPosition}</Text>
                </Col>
                <Col xs={24} lg={12}>
                  <Title level={5}>{t("contracts.fields.status")}</Title>
                  <Text>{t(`statusTypes.${record__?.status}`)}</Text>

                  <Title level={5}>{t("contracts.fields.date")}</Title>
                  <DateField value={dayjs(record__?.date)} format="LL" />

                  <Title level={5}>{t("contracts.fields.file")}</Title>
                  <Row gutter={10}>
                  {record__?.images?.map((data: any) => {
                    return (
                      <Col xs={24} lg={12}>
                      <FileField
                        target="_blank"
                        title={data?.name}
                        src={data?.url}
                      /></Col>
                    );
                  })}
                  {/*<FileField src={record.image[0].url} />*/}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Show>
      </Modal>
      <CreateContract
        drawerProps={createContractsDrawerProps}
        formProps={createContractsFormProps}
        saveButtonProps={createContractsSaveButtonProps}
        initialValues={{
          project: `${API_URL}/projects/${record.id}`,
          status: "live",
        }}
      />

      <EditContract
        drawerProps={editContractsDrawerProps}
        formProps={editContractsFormProps}
        saveButtonProps={editContractsSaveButtonProps}
      />
    </>
  );
};
